module.exports = {
  BASE_URL:`${process.env.VUE_APP_URL}`,
};
